import { useState } from 'react';
import { ExpandMore as ExpandIcon } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useSCIMTokenContext } from 'context';
import { localeDateTime } from 'utilities';

const RevokedTokens = () => {
  const { tokens } = useSCIMTokenContext();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const revokedTokens = (tokens ?? []).filter(token => token.revoked_at);
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - revokedTokens.length) : 0;

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  if (revokedTokens.length === 0) {
    return null;
  }
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandIcon />} aria-controls="revoked-tokens-content" id="revoked-tokens-header">
        <Typography variant="h4">Revoked Tokens</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Token Prefix</TableCell>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>Created At</TableCell>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>Revoked At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? revokedTokens.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : revokedTokens
              ).map(token => (
                <TableRow key={token.id}>
                  <TableCell>{token.token_prefix}</TableCell>
                  <TableCell sx={{ textAlign: 'right' }}>{localeDateTime(token.created_at as string)}</TableCell>
                  <TableCell sx={{ textAlign: 'right' }}>{localeDateTime(token.revoked_at as string)}</TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, { label: 'All', value: -1 }]}
                  colSpan={3}
                  count={revokedTokens.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        'aria-label': 'rows per page',
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default RevokedTokens;
